import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '@shared/components/button/button.module';
import { DirectivesModule } from '@shared/directives/directives.module';

import { FormFieldCrudControlsComponent } from './form-field-crud-controls.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DirectivesModule
  ],
  declarations: [FormFieldCrudControlsComponent],
  exports: [FormFieldCrudControlsComponent]
})
export class FormFieldCrudControlsModule { }
